import merge from 'lodash/merge.js';

import BaseActivity from '@/store/modules/base/BaseActivity.js';

export default merge(BaseActivity, {
    autoImport: false,
});
